import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { tint } from 'polished';

import colors from 'shared-assets/lib/colors';
import Icon from 'shared-assets/components/Icon';
import IconButton from 'shared-assets/components/IconButton';
import ReadMore from 'shared-assets/components/ReadMore';

const BannerBorder = styled.div`
  border-top: 3px solid ${props => props.color};
  & > div {
    display: flex;
    padding: 1rem;
  }
`;

const Wrapper = styled.div`
  background: #fff;
  border: 1px solid ${tint(0.85, colors.secondary)};
`;

export const BannerMessage = styled.span`
  line-height: 1.25rem;
  margin-top: -0.0625rem;
  flex: 1 1;
  & > div {
    display: inline-block;
  }
`;

const Banner = props => {
  return (
    <Wrapper style={props.style}>
      <BannerBorder color={colors[props.type]}>
        <div data-testid="banner-wrapper">
          <If condition={!!props.message}>
            <If condition={props.includeIcon}>
              <Icon
                type={
                  props.type === 'error' || props.type === 'warning'
                    ? 'attention-alt'
                    : `${props.type}-alt`
                }
                fillColor={colors[props.type]}
                size={1}
                style={{
                  marginRight: '0.5rem',
                  lineHeight: '1.5rem',
                }}
              />
            </If>
            <BannerMessage data-testid="banner-message">
              <ReadMore truncateMessage={props.truncateMessage}>
                {props.message}
              </ReadMore>
            </BannerMessage>
          </If>
          <If condition={!!props.children}>{props.children}</If>
          <If condition={typeof props.onClose === 'function'}>
            <IconButton icon="close" onClick={props.onClose} />
          </If>
        </div>
      </BannerBorder>
    </Wrapper>
  );
};

Banner.defaultProps = {
  children: undefined,
  includeIcon: false,
  message: undefined,
  onClose: undefined,
  style: {},
  truncateMessage: true,
};

Banner.propTypes = {
  children: PropTypes.node,
  includeIcon: PropTypes.bool,
  message: PropTypes.string,
  onClose: PropTypes.func,
  style: PropTypes.object,
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info']).isRequired,
  truncateMessage: PropTypes.bool,
};

export default Banner;
